import LocaleHubPage from "@/components/hub/LocaleHubPage";
import { localeHubProps } from "@/utils/localeHubProps";

// Reached through the next.config.mjs rewrite of the /es and /pt hub slugs.
export default LocaleHubPage;
export const getServerSideProps = localeHubProps;
